var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn-stats",class:{
    active: _vm.active
  },attrs:{"aria-label":"Stats"},on:{"click":function () { return _vm.$emit('click'); }}},[_c('InlineSvg',{class:{ active: _vm.active },attrs:{"width":"12px","height":"12px","alt":"Stats","icon":require("public/images/inline/widget.svg")}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }